import styled from 'styled-components';
import { NextPage } from 'next';

export const Button = styled.div`
  background-color: transparent;
  border-radius: 60px;
  padding: 0px 0px;
  height: 56px;
  width: 276px;
  display: flex;
  text-align: center;
  align-items: center;
  align-content: center;
  justify-content: center;
`;
export const ZapisatSjaNaUrok = styled.p`
  color: ${(props) => props.theme.colors.purple};
  text-transform: uppercase;
  letter-spacing: 0.48px;
  font-family: ${(props) => props.theme.fonts.desktopBodyButton.family};
  font-size: ${(props) => props.theme.fonts.desktopBodyButton.size};
  font-weight: ${(props) => props.theme.fonts.desktopBodyButton.weight};
  line-height: ${(props) => props.theme.fonts.desktopBodyButton.lineHeight};
`;

type ButtonI = {
  className?: string;
  text: string;
};

const ButtonComponent: NextPage<ButtonI> = ({
  text,
  className,
}): JSX.Element => {
  return (
    <Button className={className}>
      <ZapisatSjaNaUrok>{text}</ZapisatSjaNaUrok>
    </Button>
  );
};

export default ButtonComponent;
